import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EfsBaseService } from './efs-base.service';
import { AppFavorites } from '../dto/app-favorite.dto';
import { SurveySubmission } from '../dto/survey-submission.dto';
import { Survey } from '../dto/survey.dto';

@Injectable({ providedIn: 'root' })
export class LandingpageService extends EfsBaseService {
  getMyApps(): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('app/my'),
      undefined,
    );
    return uOb;
  }

  getMyAppFavorites(): Observable<AppFavorites[]> {
    const uOb = this.query<AppFavorites[]>(
      this.http,
      this.apiUrl('app/my-favorites'),
      undefined,
    );
    return uOb;
  }

  addMyAppFavorite(appId: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('app/my-favorites/add/' + appId),
      undefined,
    );
    return uOb;
  }

  removeMyAppFavorite(appId: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('app/my-favorites/remove/' + appId),
      undefined,
    );
    return uOb;
  }

  upMyAppFavorite(appId: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('app/my-favorites/up/' + appId),
      undefined,
    );
    return uOb;
  }

  downMyAppFavorite(appId: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('app/my-favorites/down/' + appId),
      undefined,
    );
    return uOb;
  }

  getFaqById(id: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('faq/' + id),
      undefined,
    );
    return uOb;
  }

  getFaqByAppId(appId: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('faq/byapp/' + appId),
      undefined,
    );
    return uOb;
  }

  getMyNews(search: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl(`news/my?search=${search}`),
      undefined,
    );
    return uOb;
  }

  getMyNewsReads(): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('news/my/reads'),
      undefined,
    );
    return uOb;
  }

  getNewsById(id: string): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('news/' + id),
      undefined,
    );
    return uOb;
  }

  getMotds(): Observable<any> {
    const uOb = this.query<any>(
      this.http,
      this.apiUrl('motd/my'),
      undefined,
    );
    return uOb;
  }

  getMySurveys(search: string): Observable<Survey[]> {
    const uOb = this.query<Survey[]>(
      this.http,
      this.apiUrl(`survey/my?search=${search}`),
      undefined,
    );
    return uOb;
  }

  getSurvey(id: string): Observable<Survey> {
    const uOb = this.query<Survey>(
      this.http,
      this.apiUrl(`survey/${id}`),
      undefined,
    );
    return uOb;
  }

  submitSurvey(surveyId: string, submission: SurveySubmission): Observable<any> {
    const uOb = this.queryPost<any>(
      this.http,
      this.apiUrl(`survey/${surveyId}/submit`),
      submission,
    );
    return uOb;
  }

  skipSurvey(surveyId: string): Observable<any> {
    const uOb = this.queryPost<any>(
      this.http,
      this.apiUrl(`survey/${surveyId}/skip`),
      {},
    );
    return uOb;
  }
}
